<template>
    <intersect rootMargin="-110px 0px 0px 0px" :threshold="[1]" @change="updateFixedStatus">
        <div class="wrapper">
            <div :class="`convention-sections-filters ${sticky ? 'sticky' : ''}`">
                <main-container>
                    <v-row v-if="!isAllCsp">
                        <v-col cols="3" class="tab-label-wrapper">
                            <slot name="tab-label" v-if="sticky">
                                {{ tabLabel }}
                            </slot>
                        </v-col>
                        <v-col class="col" v-for="(csp, cspCode) in csps" :key="csp._uid">
                            <v-btn
                                width="100%"
                                :disabled="isDisabled(cspCode)"
                                :outlined="!isSelected(cspCode)"
                                @click="toggle(cspCode)"
                                :color="csp.color"
                                :small="$vuetify.breakpoint.width <= 1400"
                            >
                                {{ csp.label }}
                                <v-icon v-if="isSelected(cspCode)" right dark>mdi-check</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="isAllCsp">
                        <v-col cols="3" class="tab-label-wrapper">
                            <div v-if="sticky">
                                {{ tabLabel }}
                            </div>
                        </v-col>
                        <v-col class="col all-csp-button-tab">
                            <v-btn width="100%" :disabled="true">
                                <typo name="body-12-normal" class="all-csp-button-text">
                                    {{ dico.allCsp }}
                                </typo>
                            </v-btn>
                        </v-col>
                    </v-row>
                </main-container>
            </div>
        </div>
    </intersect>
</template>

<script>
import Intersect from "vue-intersect";
import { get } from "lodash";

export default {
    props: ["cspFilters", "convention", "isAllCsp"],
    components: { Intersect },
    data() {
        return {
            sticky: false,
        };
    },
    methods: {
        updateFixedStatus(entries) {
            this.sticky = !entries[0].isIntersecting && entries[0].intersectionRect.top <= 132;
        },
        toggle(cspCode) {
            if (this.isSelected(cspCode)) {
                this.$emit(
                    "change",
                    this.cspFilters.filter(value => value !== cspCode)
                );
            } else {
                this.$emit("change", this.cspFilters.concat([cspCode]));
            }
        },
        isSelected(cspCode) {
            return this.cspFilters.indexOf(cspCode) > -1;
        },
        isDisabled(cspCode) {
            const codes = get(this.convention, "cspConfig.availableCodes", []);
            return codes.indexOf(cspCode) == -1;
        },
    },
    computed: {
        csps() {
            return this.$privateDico.convention.csps;
        },
        dico() {
            return this.$privateDico.convention.filters;
        },
        tabLabel() {
            const tabKey = this.$route.name.replace("convention-", "");
            return this.$privateDico.convention.menu[tabKey]
                ? this.$privateDico.convention.menu[tabKey].label
                : null;
        },
    },
};
</script>

<style scoped lang="sass">
.wrapper
    height: 68px

.convention-sections-filters
    padding: $grid-gutter/2
    transition: background .15s ease, padding .15s ease
    &.sticky
        position: fixed
        top: 115px
        width: 100%
        z-index: 8
        left: 0
        background: white
        box-shadow: 0 0 2px rgba(0,0,0,0.5)
        // animation: appear .5s ease-out
        padding: $grid-gutter/2

.v-application .v-btn
    margin-top: 0
    color: white
    font-size: 11px

.col
    width: 100px

.all-csp-button-text
    color: $color-text

.tab-label-wrapper
    display: flex
    align-items: center
    text-transform: uppercase
    color: $color-main

@keyframes appear
    0%
        opacity: 0
    100%
        opacity: 1

@media print
    .wrapper
        margin: 7.5mm 0 0
        height: auto

    .convention-sections-filters
        padding: 0

        &.sticky
            position: static
            padding: 0
            box-shadow: none

    .v-application .v-btn
        height: auto
        padding: 1.5mm 2mm
        box-shadow: none !important
        font-size: 7pt
        letter-spacing: 0.025em

    .row
        flex-wrap: nowrap
        justify-content: flex-end
        margin: 0 0 0 30%

    .col
        padding: 0
        &:not(.all-csp-button-tab)
            max-width: 20%
        + .col
            margin-left: 1mm

    .col-3
        flex: 0 0 0
        width: 0
</style>
